import { z } from 'zod';

import { schemaApplicantAttribution, schemaBigDecimal, schemaId } from '../../../utils/schema.utils';

export const PrivateKrankenversicherungUndUnterhaltsverpflichtung = z.object({
    betragMonatlich: schemaBigDecimal.nullish().default(null),
    gehoertZuAntragsteller: schemaApplicantAttribution,
    id: schemaId,
});
